export default __webpack_public_path__ + "static/slide1-tablet-270b99d003b3a14d2c68e94da81a3e68.png";